import { Directive, HostListener, Input, OnInit } from '@angular/core'
import { TipoDeOperador } from './../../pkw-data/core/tipo-de-operador.enum';
import { Operador } from './../../pkw-data/core/operador.model';
import { OperadorService } from './../../core/services/operador.service';
import { BureauService } from './../../core/services/bureau.service';
import { Bureau } from './../../pkw-data/core/bureau.model';

@Directive({
    selector: '[eventTracker]'
})
export class buttonExportacaoMovimentoDirective implements OnInit{
    @Input('eventTracker') option: any

    operador: Operador
    id: string
    login: number
    nome: string
    tipo: TipoDeOperador
    bureau: Bureau
    crm: number

    @HostListener('click', ['$eventTracker']) onClick($event) {

        (<any>window).ga(
            'set',
            {
                'userId': this.id,
                'dimension1': this.login,
                'dimension2': this.nome,
                'dimension3': this.tipo,
                'dimension4': this.crm,
            }
        ),

        (<any>window).ga(
            'send',
            'event',
            'Exportar movimento',
            'Clique no botão Exportar',
            'Extratos'
        )
    }
    constructor(
        private operadorService: OperadorService,
        private bureauService: BureauService
    ) {}

    ngOnInit() {
        this.obterOperador()
        this.dadosAnalytics()
    }

    private obterOperador() {
        this.operadorService.corrente.subscribe(operador => {
            this.operador = operador

        })
        this.bureauService.corrente.subscribe(bureau => {
            this.bureau = bureau
        })
    }

    private dadosAnalytics(){
            this.id = this.operador.id
            this.login = this.operador.login
            this.nome = this.operador.nome
            this.tipo = this.operador.tipo
            this.crm = this.bureau.userConnection.crm

    }
}





// WEBPACK FOOTER //
// ./src/app/extratos/exportacao-movimento/exportacao-movimento.directive.ts